import * as fromDatatype from "../datatype-library";

export interface bl_alg_cc_rule_hdr_RowInterface {
    guid : fromDatatype.GuidDataFieldInterface; 
    parent_guid: fromDatatype.GuidDataFieldInterface;
    automation_rule_hdr_guid: fromDatatype.GuidDataFieldInterface;
    namespace : fromDatatype.VarcharDatatypeClass;
    module_guid : fromDatatype.GuidDataFieldInterface ;
    applet_guid : fromDatatype.VarcharDatatypeInterface ;
    code : fromDatatype.VarcharDatatypeInterface;
    rule_type : fromDatatype.VarcharDatatypeInterface;
    rule_name: fromDatatype.VarcharDatatypeInterface;
    left_hand_side: fromDatatype.VarcharDatatypeInterface;
    operator: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
    negation: boolean;
    is_parent: boolean;
    priority: fromDatatype.IntegerDatatypeInterface;
    property_json : fromDatatype.JsonDatatypeInterface;
    acl_config : fromDatatype.JsonDatatypeInterface;
    acl_policy : fromDatatype.JsonDatatypeInterface;
    created_date : fromDatatype.TimestampTzDatatypeInterface ;
    updated_date : fromDatatype.TimestampTzDatatypeInterface ;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface ;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface ;
    status : fromDatatype.StatusDataFieldInterface;
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn : fromDatatype.VarcharDatatypeInterface;
    right_hand_side_type : fromDatatype.VarcharDatatypeInterface;
    right_hand_side_string : fromDatatype.VarcharDatatypeInterface;
    right_hand_side_numeric : fromDatatype.NumericDatatypeInterface;
    right_hand_side_datetime : fromDatatype.TimestampTzDatatypeInterface;
    right_hand_side_boolean :boolean;
    right_hand_side_json : fromDatatype.JsonDatatypeInterface;
}

export class bl_alg_cc_rule_hdr_RowClass
  implements bl_alg_cc_rule_hdr_RowInterface {
    guid : fromDatatype.GuidDataFieldInterface; 
    parent_guid: fromDatatype.GuidDataFieldInterface;
    automation_rule_hdr_guid: fromDatatype.GuidDataFieldInterface;
    namespace : fromDatatype.VarcharDatatypeClass;
    module_guid : fromDatatype.GuidDataFieldInterface ;
    applet_guid : fromDatatype.VarcharDatatypeInterface ;
    code : fromDatatype.VarcharDatatypeInterface;
    rule_type : fromDatatype.VarcharDatatypeInterface;
    rule_name: fromDatatype.VarcharDatatypeInterface;
    left_hand_side: fromDatatype.VarcharDatatypeInterface;
    operator: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
    negation: boolean;
    is_parent: boolean;
    priority: fromDatatype.IntegerDatatypeInterface;
    property_json : fromDatatype.JsonDatatypeInterface;
    acl_config : fromDatatype.JsonDatatypeInterface;
    acl_policy : fromDatatype.JsonDatatypeInterface;
    created_date : fromDatatype.TimestampTzDatatypeInterface ;
    updated_date : fromDatatype.TimestampTzDatatypeInterface ;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface ;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface ;
    status : fromDatatype.StatusDataFieldInterface;
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn : fromDatatype.VarcharDatatypeInterface;
    right_hand_side_type : fromDatatype.VarcharDatatypeInterface;
    right_hand_side_string : fromDatatype.VarcharDatatypeInterface;
    right_hand_side_numeric : fromDatatype.NumericDatatypeInterface;
    right_hand_side_datetime : fromDatatype.TimestampTzDatatypeInterface;
    right_hand_side_boolean :boolean;
    right_hand_side_json : fromDatatype.JsonDatatypeInterface;
  }